export const customAlert = (error) => alert(error);
